import { City, Suburb } from '@/types/api/cities.types';

export type VendorCityRefreshContext = 'org-cities' | 'db-cities' | 'both';

export enum VendorSource {
  custom = 'CUSTOM',
  central = 'BOQPAY',
}

export type PaymentDetails = {
  bankName: string | null;
  bankAccountNumber: string | null;
  branchCode?: string | null;
  vatNumber: string | null;
  vatRegistered: boolean;
  codSupported: boolean;
  accountSupported: boolean;
  accountType: string | null;
};

export type VendorBody = {
  source?: string;
  organisationId?: string | null;
  accountNumber?: string | null;
  name: string;
  description: string | null;
  city: string | null;
  suburb: string | null;
  addressLine1: string | null;
  country: string | null;
  contactName: string | null;
  contactEmail: string;
  accountEmail: string | null;
  contactNumberCountryCode: string | null;
  contactNumber: string | null;
  paymentDetails: PaymentDetails;
  landlineNumber: string | null;
};

export type ContactDetails = {
  name: string;
  contactNumber: string;
  email: string;
  accountEmail?: string;
  contactNumberCountryCode: string;
  landlineNumber: string;
};

export type Vendor = {
  id: string;
  parentId: string | null;
  name: string;
  source: string;
  city: string;
  suburb: string;
  country: string;
  addressLine1: string;
  description: string;
  organisationId: string;
  contactDetails: ContactDetails;
  paymentDetails: PaymentDetails;
  accountNumber: string;
  profileImageName: string;
  profileImageUrl: string;
  BOQSynced?: boolean;
  hasAccount?: boolean;
  accountPayableId?: string | null;
};

/** How many organisations hold a synced copy of a central vendor. */
export type SyncedOrganisationCount = {
  count: number;
};

export type VendorSync = {
  organisationId: string;
  vendorIds: string[];
};

export type FilterVendorType = {
  name: string;
  source: string;
  orgId: string | null;
};

export type VendorFilters = FilterVendorType & City & Suburb;

export type VendorItem = {
  id: string;
  name: string;
  description: string;
  type: string;
  unitType: string;
  unitTypeShortName: string;
  skuNumber: string;
  source: string;
  vendorId: string;
  vendorName: string;
  parentId: string | null;
  organisationId: string;
  rate: number;
  lastPaidRate: number;
};

export type VendorItemType = {
  id: string;
  name: string;
};

type BaseFilter = {
  pageNo?: number | string;
  pageSize?: number;
  orderBy?: string;
  orderByDesc?: string;
  source?: string;
};

export type VendorParams = BaseFilter & {
  organisationId?: string | null;
  city?: string;
  suburb?: string;
  parentId?: string;
  name?: string;
  ids?: string[];
};

export type LocationParams = {
  orgId?: string | null;
  city?: string;
};

export type VendorItemParams = BaseFilter & {
  type?: string;
  organisationId?: string | null;
  name?: string;
};

export type BulkUpload = {
  id: string;
  body: FormData;
};

export type BulkUploadError = {
  error: string;
  fieldName: string;
  fieldValue: string;
  lineNumber: number;
};

export type BulkUploadResponse = {
  errorCount: number;
  errors: BulkUploadError[];
  recordsCreated: number;
};
